var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2568 8.13867C19.0214 6.77937 20.9786 6.77937 21.7432 8.13867L34.6133 31.0195C35.3632 32.3527 34.3998 34 32.8701 34H7.12988C5.60023 34 4.63679 32.3527 5.38672 31.0195L18.2568 8.13867Z",
    stroke: "#49247D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25L19 25V17H21V25Z",
    fill: "#49247D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7125 28.7125C20.5208 28.9042 20.2833 29 20 29C19.7167 29 19.4792 28.9042 19.2875 28.7125C19.0958 28.5208 19 28.2833 19 28C19 27.7167 19.0958 27.4792 19.2875 27.2875C19.4792 27.0958 19.7167 27 20 27C20.2833 27 20.5208 27.0958 20.7125 27.2875C20.9042 27.4792 21 27.7167 21 28C21 28.2833 20.9042 28.5208 20.7125 28.7125Z",
    fill: "#49247D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageAlert);
export default __webpack_public_path__ + "static/media/page_alert.9bae59c69bc26cfdd3b797ea425d1302.svg";
export { ForwardRef as ReactComponent };